import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {BadgeActivity} from "../../services/models/badges/BadgeActivity";

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent implements OnInit {
  // @Input()name: string = "";
  // @Input()color: string = "";
  @Input()level: number = 0;
  @Input()showCaption: boolean = false;
  @Input()activityData!: BadgeActivity;
  @Input()size: number = 10;
  @Input()showTitle: boolean = false;
  currentIconLevels: number = 0;
  currentIconLevel: number = 0;
  currentIndex: number = 0;

  constructor() { }
  ngOnChanges(changes: SimpleChanges) {
    this.reinitComponent();
  }
  reinitComponent() {
    if (this.level == 0) {
      this.currentIndex = 0;
      this.currentIconLevel = 0;
    } else {
      this.currentIndex = this.level - 1;
    }
    let currLevel = this.activityData.levels[this.currentIndex];
    if (currLevel) {
      this.currentIconLevels = this.activityData.levels.filter(i => i.iconCss === currLevel.iconCss).length;
      let minCurrentIndex = this.activityData.levels.findIndex(i => i.iconCss === currLevel.iconCss);
      this.currentIconLevel = this.level - minCurrentIndex;
    }
  }
  ngOnInit() {

  }

}
